import CustomVideoPlayer from '../../CustomVideoPlayer'
import ImageBox from './components/ImageBox'


export default {CustomVideoPlayer, ImageBox}
